import { Employee } from "@/Common/Api/Employee/Dto/Employee";
import { ClickToDialViewMode } from "@/Common/Components/CallCenter/ClickToDial.types";
import { ClickToDialView } from "@/Common/Components/CallCenter/ClickToDialView";
import { EmployeeTitleHelper } from "@/Common/Helpers/EmployeeTitleHelper";
import { Guid } from "@/Common/Models/Guid";
import { PatientRefIntervenorWithDetailsModel } from "@/Common/Models/Patient/PatientRefIntervenorWithDetailsModel";
import { IPatientCliniciansModel } from "@/Common/Models/Patient/UI/Profile/IPatientCliniciansModel";
import { Person } from "@/Common/Models/Person/Person";
import { RedirectTo } from "@/Common/Models/UI/Enums";
import { KeyValuePair } from "@/Common/Models/UI/KeyValuePair";
import * as LocalOperations from "@/Common/Operations/operations.local";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { RouterHistory } from "@/Common/Utilities/Router/RouterHistory";
import { ProtectPatientFileSection } from "./ProtectPatientFileSection";

import img_icon_favorite from "@/Globals/_images/icons/Favorite.png";

interface IPatientProfileCliniciansProps {
    Model: IPatientCliniciansModel;
}

class CliniciansView extends React.Component<IPatientProfileCliniciansProps, any> {
    private PageContentMargin: React.CSSProperties = { marginLeft: "45px" };
    private tdPadding: React.CSSProperties = { paddingRight: "15px" };
    private tdPaddingMD: React.CSSProperties = { paddingRight: "15px", width: "300px" };
    private tdPaddingRightText: React.CSSProperties = { paddingRight: "15px", textAlign: "right", width: "270px" };

    private spacer: React.CSSProperties = { marginRight: "5px", marginLeft: "5px" };

    public componentDidMount(): void {
        $(window).trigger("resize");
    }

    public render(): JSX.Element {
        var internalIntervenors = this.props.Model.get("IntervenorsOnFile").filter(x => x.IsFromClinic() == true);
        var exterrnalIntervenors = this.props.Model.get("IntervenorsOnFile").filter(x => x.IsFromClinic() != true);

        var specialityCategoriesInternal = this.groupByCategory(internalIntervenors);
        var specialityCategoriesExternal = this.groupByCategory(exterrnalIntervenors);

        return (
            <div className="patient-prof">
                <div className="scrollable">
                    <div className="block separated" data-cy="clinicians-internalProvider">
                        <div className="flex-container heading">
                            <div><h3 className="h thin-font">{cacheStore.GetString("TreatingStaffLabel")}</h3></div>
                            {patientStore.CanEditPatient &&
                                <div style={{ paddingTop: "10px", paddingRight: "20px" }} onClick={this.onAddIntervenorOpen.bind(this, true)} data-cy="clinicians-add-internalProvider"><a>{"[+] " + cacheStore.GetString("AddStaffMembersInternalLabel")}</a></div>
                            }
                        </div>
                        <div style={this.PageContentMargin}>
                            {specialityCategoriesInternal != null && specialityCategoriesInternal.map((Category, idx) => {
                                var CategoryName = Category.Key;

                                return (
                                    <div key={"_cat_Clinic" + idx}>
                                        <div style={{ marginTop: "15px", marginBottom: "5px", fontSize: "20px" }}><strong>{CategoryName}</strong></div>
                                        <div style={{ marginLeft: "20px" }}>
                                            <table>
                                                {Category.Value != null && Category.Value.map((c, idx) => {
                                                    if (c.IsFromClinic() == true)
                                                        return this.renderMyleIntervenor(c, idx);
                                                    else
                                                        return this.renderExternalIntervenor(c, idx);
                                                })}
                                            </table>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {specialityCategoriesExternal != null && (
                        <div className="block separated" data-cy="clinicians-externalProvider">
                            <div className="flex-container heading">
                                <div><h3 className="h thin-font">{cacheStore.GetString("ExternalConsultantLabel")}</h3></div>
                                {patientStore.CanEditPatient &&
                                    <div style={{ paddingTop: "10px", paddingRight: "20px" }} onClick={this.onAddIntervenorOpen.bind(this, false)} data-cy="clinicians-add-externalProvider"><a>{"[+] " + cacheStore.GetString("AddStaffMembersExternalLabel")}</a></div>
                                }
                            </div>

                            <div style={this.PageContentMargin}>
                                {specialityCategoriesExternal.map((Category, idx) => {
                                    var CategoryName = Category.Key;

                                    return (
                                        <div key={"_cat_Clinic" + idx}>
                                            <div style={{ marginTop: "15px", marginBottom: "5px", fontSize: "20px" }}><strong>{CategoryName}</strong></div>
                                            <div style={{ marginLeft: "20px" }}>
                                                <table>
                                                    {Category.Value != null &&

                                                        Category.Value.map((c, idx) => {
                                                            if (c.IsFromClinic() == true)
                                                                return this.renderMyleIntervenor(c, idx);
                                                            else
                                                                return this.renderExternalIntervenor(c, idx);
                                                        })
                                                    }
                                                </table>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {cacheStore.ClinicSettings.EnablePatientChartAllowlist && this.renderProtectMedicalFileSection()}

                </div>
            </div>
        );
    }

    private renderMyleIntervenor(c: PatientRefIntervenorWithDetailsModel, idx: number): JSX.Element {
        return (
            <tbody style={{ borderBottom: "15px solid white" }} key={"clinician_" + idx}>
                <tr>
                    <td style={this.tdPaddingRightText}>
                        <div>
                            {c.Model.Intervenor.IsPrimary == true &&
                                <img style={{ "marginTop": "-4px", "height": "15px" }} id="_FavOn" src={img_icon_favorite} />
                            }
                            <span> {c.GetLicenceOrganisatioRuleName()}</span>
                        </div>
                    </td>
                    <td style={this.tdPaddingMD}>
                        <div>
                            <strong>
                                <span> {c.GetName()}</span>
                            </strong>
                            <span> {c.GetLicence(true)}</span>

                        </div>
                    </td>
                    <td style={this.tdPadding}>
                        <div style={{ width: "60px" }}>
                            <span> {c.GetOrganizationAcronym()}</span>
                        </div>
                    </td>
                    <td>
                        <div style={{ width: "90px" }} />
                    </td>
                    <td style={this.tdPadding}>
                        <div className="flex-container" style={{ justifyContent: "flex-start" }}>
                            <div>
                                <a onClick={this.naviguateToCalendar.bind(this, c.Employee.ContactId)}> {cacheStore.GetString("CalendarMenuLabel")}</a>
                            </div>
                            <div style={this.spacer}>/</div>
                            <div>
                                <a onClick={() => this.onSend(c.Employee.ContactFacetId, false)}>{cacheStore.GetString("MessageLabel")}</a>
                            </div>
                            <div style={this.spacer}>/</div>
                            <div>
                                <a onClick={() => this.onSend(c.Employee.ContactFacetId, true)}>{cacheStore.GetString("TaskLabel")}</a>
                            </div>

                        </div>
                    </td>

                </tr>
                {!IsNullOrWhiteSpace(c.Model.Intervenor.Note) && (
                    <tr>
                        <td style={this.tdPaddingRightText}>
                            <div>
                                <span> Note:</span>
                            </div>
                        </td>
                        <td style={this.tdPaddingMD}>
                            <div>
                                <span> {c.Model.Intervenor.Note}</span>
                            </div>
                        </td>
                    </tr>
                )}
            </tbody>
        );
    }

    private renderExternalIntervenor(c: PatientRefIntervenorWithDetailsModel, idx: number): JSX.Element {
        const callCenterFeatureFlag: boolean = cacheStore.ClinicSettings.IsCallCenterEnabled();
        let phoneElement: JSX.Element = <>{c.GetPhone()}</>;
        if (callCenterFeatureFlag) {
            phoneElement = <ClickToDialView viewMode={ClickToDialViewMode.Hyperlink} formattedPhoneNumber={c.GetPhone()} forActivePatient />;
        }
        return (
            <tbody style={{ borderBottom: "25px solid white" }} key={"clinician_ex_" + idx}>
                <tr>
                    <td style={this.tdPaddingRightText}><div><span> {c.GetLicenceOrganisatioRuleName()}</span></div></td>
                    <td style={this.tdPaddingMD}>
                        <div>
                            <strong>
                                <span> {c.GetName()}</span>
                            </strong>
                            <span> {c.GetLicence(true)}</span>
                        </div>
                    </td>
                    <td style={this.tdPadding}>
                        <div style={{ width: "60px" }}>
                            <span> {c.GetOrganizationAcronym()}</span>
                        </div>
                    </td>
                </tr>
                {!IsNullOrWhiteSpace(c.GetFax()) && (
                    <tr key={"clinician_ex_Info1_" + idx}>
                        <td style={this.tdPaddingRightText}><div><span> {cacheStore.GetString("FaxLabel") + ":"}</span></div></td>
                        <td style={this.tdPaddingMD}>
                            <div>
                                <span> {c.GetFax()}</span>
                            </div>
                        </td>
                    </tr>
                )}
                {!IsNullOrWhiteSpace(c.GetPhone()) && (
                    <tr key={"clinician_ex_Info2_" + idx}>
                        <td style={this.tdPaddingRightText}><div><span> {cacheStore.GetString("PhoneLabel") + ":"}</span></div></td>
                        <td style={this.tdPaddingMD}>
                            <div>
                                <span> {phoneElement}</span>
                            </div>
                        </td>
                    </tr>
                )}
                {!IsNullOrWhiteSpace(c.GetAddress()) && (
                    <tr key={"clinician_ex_Info3_" + idx}>
                        <td style={this.tdPaddingRightText}><div><span> {cacheStore.GetString("AddressLabel") + ":"}</span></div></td>
                        <td style={this.tdPaddingMD}>
                            <div>
                                <span> {c.GetAddress()}</span>
                            </div>
                        </td>
                    </tr>
                )}
                {!IsNullOrWhiteSpace(c.Model.Intervenor.Note) && (
                    <tr>
                        <td style={this.tdPaddingRightText}>
                            <div>
                                <span> Note:</span>
                            </div>
                        </td>
                        <td style={this.tdPaddingMD}>
                            <div>
                                <span> {c.Model.Intervenor.Note}</span>
                            </div>
                        </td>
                    </tr>
                )}
            </tbody>
        );
    }

    private renderProtectMedicalFileSection(): JSX.Element {
        return (
            <ProtectPatientFileSection
                editable={false}
                model={this.props.Model.get("PatientFileAllowlist")}
                onMembersChange={(membersToAdd, membersToDelete) => this.onProtectPatientFileChange(membersToAdd, membersToDelete)}
            />
        );
    }

    private groupByCategory(intervenors: Immutable.Iterable<number, PatientRefIntervenorWithDetailsModel>): KeyValuePair<string, PatientRefIntervenorWithDetailsModel[]>[] {
        return intervenors
            .groupBy(x => x.GetSpecialisationCategoryName())
            .map((x, categoryName) => {
                const items = x
                    .toArray()
                    .sortByProperty(x => x.GetName())
                    .sortByProperty(employee => EmployeeTitleHelper.isDoctor(Employee.getTitle(employee.Employee?.Model)), true);
                return new KeyValuePair(categoryName, items);
            })
            .toArray()
            .sortByProperty(x => {
                if (x.Value[0].Model.LicenceOrganisationSpecialisation != null && x.Value[0].Model.LicenceOrganisationSpecialisation.SpecialisationCode == "0") // MD Famille
                    return -1;
                else if (x.Value.some(y => y.IsFromClinic() == true))
                    return 0;
                else
                    return x.Value[0].GetSpecialisationCategory().Position;
            });
    }

    private onAddIntervenorOpen(IsInternal: boolean): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Clinicians_EditClick);
        operation.AddItem("OpenAddIntervenorPopup", true);
        operation.AddItem("IsInternal", IsInternal);
        LocalEventDispatcher.dispatch(operation);
    }

    private naviguateToCalendar(EmployeeContactId: string): void {
        var operation = new LocalEvent(LocalOperations.Misc.RedirectToTab);
        operation.AddItem("value", EmployeeContactId);
        operation.AddItem("target", RedirectTo.Calendar);
        operation.AddItem("currentLocation", RouterHistory.location);
        operation.AddItem("targetPatient", patientStore.getCurrentPatient().IndividualResponse.Contact_id);
        LocalEventDispatcher.dispatch(operation);
    }

    private onSend(EmployeeId: Guid, isTask: boolean): void {
        sessionStore.dispatch(LocalOperations.SendTaskOrMessageModel.Show_TaskOrMessage_Popup, {
            isTask: isTask,
            patient: Person.FromPatient(patientStore.getCurrentPatient()),
            Employee: cacheStore.GetEmployeeByContactFacetId(EmployeeId)
        });
    }

    private onProtectPatientFileChange(membersToAdd: Guid[] | null, membersToDelete: Guid[] | null): void {
        sessionStore.dispatch(
            LocalPatientOperations.Profile.Clinicians_EditPatientFileAllowlist,
            { membersToAdd, membersToDelete }
        );
    }
}

export { CliniciansView, IPatientProfileCliniciansProps };
